// Scroll restoration for the app frame.
//
// The signed-in shell is fixed to the viewport and .app-body scrolls inside it,
// which is what lets overlays be positioned against the frame. The cost is that
// the document never scrolls, so Turbo's own scroll restoration — which reads
// and writes window.scrollY — has nothing to restore, and going Back landed you
// at the top of a list you had scrolled a long way down.
//
// So: remember where the scroller was as each page leaves, and put it back when
// the browser goes Back or Forward. Forward navigation is untouched, because a
// new page should start at the top and does so anyway — .app-body is a fresh
// element on every render.

const positions = new Map<string, number>()

// Only a Back/Forward restores. Turbo doesn't expose the visit's action on
// turbo:load, so this tracks the one event that unambiguously means it: the
// browser's own popstate, which fires before Turbo has finished rendering.
let restoring = false

function scroller() {
  return document.getElementById('app-body')
}

export function initAppScroll() {
  // before-cache is the last moment the outgoing page is still in the document
  // and still scrolled where the reader left it.
  document.addEventListener('turbo:before-cache', () => {
    const el = scroller()
    if (el) positions.set(window.location.href, el.scrollTop)
  })

  window.addEventListener('popstate', () => {
    restoring = true
  })

  document.addEventListener('turbo:render', () => {
    if (!restoring) return
    restoring = false

    const top = positions.get(window.location.href)
    if (top === undefined) return

    // Inside the render callback, before the browser captures the incoming
    // snapshot — same reasoning as the nav indicator. Set here, the page is
    // captured already scrolled, so the crossfade doesn't show the top of the
    // list for a beat before jumping.
    const el = scroller()
    if (el) el.scrollTop = top
  })
}
